// test847
(847 && 0);
